const CLOUD_NAME = "dphwb0sjp";
export const API = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;
export const PRESET = "gekkrxcd";
